import { Divider, SegmentedControl, Text } from '@byecode/ui'
import type { DataSourceAbstract } from '@lighthouse/core'
import { Group4ByecodeUi, ListItem4ByecodeUi } from '@lighthouse/shared'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'

import { chartAxisOptions, chartSortOptions, dataSettingSwitchList } from '../../constants'
import { BaseDataConfigurator } from '../BaseDataConfigurator'
import type { ChartFormSlice } from '../formSlice'

interface DataConfiguratorProps {
    dataSource: DataSourceAbstract
    enableSortConfigurator?: boolean
}

export const DataConfigurator: React.FC<DataConfiguratorProps> = ({ dataSource, enableSortConfigurator }) => {
    const { control } = useFormContext<ChartFormSlice>()
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()

    const dataSourceList = useDataSourceList(appId, envId)

    // 筛选器blocks
    // const filterBlocks = useMemo(() => {
    //     if (!pageBlocks) {
    //         return []
    //     }
    //     return filterBlock(pageBlocks, block => block.type === 'filter') as FilterBlockAbstract[]
    // }, [pageBlocks])

    return (
        <>
            <Divider color="var(--color-gray-200)" />
            <Group4ByecodeUi label="数据设置">
                <BaseDataConfigurator dataSource={dataSource} dataSourceList={dataSourceList} switchList={dataSettingSwitchList} />

                {enableSortConfigurator && (
                    <>
                        <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                            <Text>排序依据</Text>
                            <Controller
                                control={control}
                                name="xyAxis"
                                render={({ field }) => (
                                    <SegmentedControl
                                        style={{ width: 157 }}
                                        fullWidth
                                        data={chartAxisOptions}
                                        value={field.value}
                                        onChange={field.onChange}
                                    />
                                )}
                            />
                        </ListItem4ByecodeUi>
                        <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                            <Text>排序规则</Text>
                            <Controller
                                control={control}
                                name="sortMode"
                                render={({ field }) => (
                                    <SegmentedControl
                                        style={{ width: 157 }}
                                        fullWidth
                                        data={chartSortOptions}
                                        value={field.value}
                                        onChange={field.onChange}
                                    />
                                )}
                            />
                        </ListItem4ByecodeUi>
                    </>
                )}
            </Group4ByecodeUi>
        </>
    )
}
